module.exports = __webpack_public_path__ + "static/media/history_1.0f1c2a4c.jpg";